import { configureStore } from '@reduxjs/toolkit';
import { authSlice } from './slices/authSlice';
import { agentsSlice } from './slices/agentsSlice';
import { callsSlice } from './slices/callsSlice';
import { uiSlice } from './slices/uiSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    agents: agentsSlice.reducer,
    calls: callsSlice.reducer,
    ui: uiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;